export enum Roles {
	roleDriver = 'Role.Driver',
	roleOffice = 'Role.Office',
	roleAdmin = 'Role.Admin',
	roleInternal = 'Role.Internal',
	roleCustomer = 'Role.Customer',
}

export enum Permissions {
	rightAdmin = 'Permission.Admin',
	rightCustomer = 'Permission.Customer',
	rightInternal = 'Permission.Internal',
	rightDriver = 'Permission.Driver',
	rightOffice = 'Permission.Office',
	rightBilling = 'Permission.Billing',
	rightPlanning = 'Permission.Planning',
	rightCheckReports = 'Permission.CheckReports',
	rightMasterData = 'Permission.MasterData',
}

export enum Locales {
	german = 'de-CH',
	english = 'en-US',
}

export const PerPageOptions = [10, 20, 50, 100];

export enum Salutation {
	mrs = 0,
	mr = 10,
}

export enum AddressTitle {
	dr = 0,
	prof = 10,
	ba = 20,
	bsc = 30,
	ma = 40,
	msc = 50,
}

export enum Gender {
	male = 0,
	female = 10,
}

export enum UserState {
	active = 0,
	archived = 90,
}

export enum UserCreateType {
	uctDriver = 10,
	uctOffice = 20,
	uctDriverAndOffice = 100,
}

export enum CompanyState {
	active = 0,
	archived = 90,
}

export enum ReportState {
	created = 0,
	checked = 10,
	billed = 20,
	locked = 30,
}

export enum BillState {
	draft = 0,
	locked = 10,
}

export enum BillSendLogType {
	email = 0,
	print = 10,
}

export enum BillCreateOption {
	addNoReports = 0,
	addAllReports = 10,
	addReportsInRange = 20,
}

export enum EmploymentType {
	freelancer = 0,
	employee = 10,
	external = 20,
}

export enum AddressType {
	contact = 0,
	billing = 10,
}

export enum AttachmentSize {
	orig = 0,
	s = 10,
	m = 20,
	l = 30
}

export enum CompanyType {
	customer = 0,
	internal = 10
}
